<template>
  <div class="paper-choice-set-stu-class-merge"></div>
</template>

<script>
export default {
  name: 'PaperChoiceSetStuClassMerge',
  props: {
    guideTeacher: {
      type: Object,
      required: true
    }
  },
  computed: {
    distributeCount () {
      let children = this.guideTeacher.children || []
      return children.reduce((p, v) => {
        return p + (v.leadCount || 0)
      }, 0)
    }
  },
  watch: {
    distributeCount: {
      handler: function (val) {
        this.$set(this.guideTeacher, 'distributeCount', val)
        let leadMaxCount = this.guideTeacher.leadMaxCount || 0
        if (leadMaxCount < val) {
          this.$nextTick(() => {
            this.guideTeacher.leadMaxCount = val
          })
        }
      }
    }
  }
}
</script>
